import FlexSection from "@/partials/sections/Section/FlexSection";
import Link from "next/link";
import React from "react";

export default function NavbarAuth({ customer }) {
  return (
    <FlexSection extraClass={"items-center gap-8"}>
      <Link href="/login" className="font-semibold py-[14px] px-6 rounded-md hover:bg-primary hover:text-white">
        Login
      </Link>
      {!customer && (
        <Link href="/member">
          <button className="bg-[#020202] text-white font-medium  py-[14px] px-6 rounded-md flex justify-center items-center gap-4 duration-300 text-sm xl:text-lg hover:bg-primary">
            Become a Member
          </button>
        </Link>
      )}
    </FlexSection>
  );
}
